import { FC } from 'react';
import { MemoryRouter, Route, Routes } from 'react-router-dom';
import { AppComponentProps } from '../types/AppComponent.props';
import { IndexPage } from './pages';
import { GamePage } from './pages/game';

export const PcApp: FC<AppComponentProps> = () => {
  return (
    <MemoryRouter>
      <Routes>
        <Route path="/" Component={IndexPage}></Route>
        <Route path="/game/*" Component={GamePage}></Route>
      </Routes>
    </MemoryRouter>
  );
};
